import React, { useState, useEffect } from 'react';
import { GoogleMap, MarkerF, InfoWindow } from '@react-google-maps/api';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';

const containerStyle = {
  width: '100%',
  height: '400px',
  position: 'relative',
};

const buttonContainerStyle = {
  position: 'absolute',
  top: '10px',
  left: '10px',
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  zIndex: 1000,
};

const infoWindowStyle = {
  maxWidth: '200px',
};

const imageStyle = {
  width: '100%',
  height: 'auto',
  position: 'relative',
};

const heartIconStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  color: 'white',
  fontSize: '24px',
  cursor: 'pointer',
};

const MapView = ({ locations, toggleLike }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [filteredLocations, setFilteredLocations] = useState(locations);
  const [category, setCategory] = useState('all');
  const [mapLoaded, setMapLoaded] = useState(false);

  const center = locations.length
    ? { lat: locations[0].lat, lng: locations[0].lon }
    : { lat: 50.0755, lng: 14.4378 };

  useEffect(() => {
    setFilteredLocations(locations);
  }, [locations, mapLoaded]);

  const handleFilterCategory = (selectedCategory) => {
    let filtered;

    if (selectedCategory === 'favorites') {
      filtered = locations.filter((location) => location.liked);
    } else if (selectedCategory === 'free') {
      filtered = locations.filter((location) => location.priceAdult === '0');
    } else {
      filtered = locations; 
    }

    setFilteredLocations(filtered);
    setCategory(selectedCategory); 
  };

  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
  };

  return (
    <div style={containerStyle}>
      <div style={buttonContainerStyle}>
        <button
          style={{
            backgroundColor: category === 'all' ? 'blue' : 'white',
            color: category === 'all' ? 'white' : 'black',
            padding: 5,
            fontSize: 12,
            cursor: 'pointer',
          }}
          onClick={() => handleFilterCategory('all')}
        >
          ALL ATTRACTIONS
        </button>
        <button
          style={{
            backgroundColor: category === 'favorites' ? 'blue' : 'white',
            color: category === 'favorites' ? 'white' : 'black',
            padding: 5,
            fontSize: 12,
            cursor: 'pointer',
          }}
          onClick={() => handleFilterCategory('favorites')}
        >
          FAVORITE ATTRACTIONS
        </button>
        <button
          style={{
            backgroundColor: category === 'free' ? 'blue' : 'white',
            color: category === 'free' ? 'white' : 'black',
            padding: 5,
            fontSize: 12,
            cursor: 'pointer',
          }}
          onClick={() => handleFilterCategory('free')}
        >
          FREE PUBLIC ENTRY
        </button>
      </div>
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={center}
        zoom={10}
        options={mapOptions}
        onLoad={() => setMapLoaded(true)} 
      >
        {filteredLocations.map((location, index) => (
          <MarkerF
            key={index}
            position={{ lat: location.lat, lng: location.lon }}
            title={location.content.en.title}
            onClick={() => setSelectedLocation(location)}
            icon={{
              url: require('../../assets/images/Mask.png'),
              scaledSize: new window.google.maps.Size(15, 20),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 30), 
            }}
          />
        ))}

        {selectedLocation && (
          <InfoWindow
            position={{ lat: selectedLocation.lat, lng: selectedLocation.lon }}
            onCloseClick={() => setSelectedLocation(null)}
          >
            <div style={infoWindowStyle}>
              <div style={{ position: 'relative' }}>
                <img
                  src={`https://static2.praguecoolpass.com/${selectedLocation.images[0]}`}
                  alt={selectedLocation.content.en.title}
                  style={imageStyle}
                />
                <div
                  style={heartIconStyle}
                  onClick={() => toggleLike(selectedLocation._id)}
                >
                  {selectedLocation.liked ? <HeartFilled /> : <HeartOutlined />}
                </div>
              </div>
              <h3>{selectedLocation.content.en.title}</h3>
              <p>{selectedLocation.address1}</p>
              <p>
                {`${selectedLocation.priceAdult || 'N/A'} Kč / ${selectedLocation.priceChild || 'N/A'} Kč`}
              </p>
              <p>{selectedLocation.benefit}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
};

export default MapView;
